import i18n from '@/utils/i18n'

const MEMBER_ROLE_KEYS = {
  1: 'member.role1',
  2: 'member.role2',
  3: 'member.role3',
  4: 'member.role4',
  5: 'member.role5',
  6: 'member.role6',
  7: 'member.role7',
  8: 'member.role8',
  9: 'member.role9'
}

export function getMemberLevelLabel (member) {
  if (!member) return '-'
  const profitType = Number(member.profit_type)
  if (Number.isFinite(profitType) && profitType > 0) {
    return i18n.t('member.levelTemplate', { level: profitType })
  }
  const role = Number(member.role)
  const key = MEMBER_ROLE_KEYS[role]
  return key ? i18n.t(key) : '-'
}

export function getMemberStatusLabel (status) {
  const value = Number(status)
  if (value === 4) return i18n.t('member.statusNormal')
  if (value === 32) return i18n.t('member.statusSuspended')
  return value ? String(value) : '-'
}
